import { useSortable } from '@dnd-kit/sortable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripVertical } from '@fortawesome/pro-light-svg-icons'
import { RosterSection } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/roster-section'
import { IRoster, ROSTER_INVITE_STATUS } from 'models/Roster'
import { GrabWrapper, PositionRelativeBox, sortableWrapperStyle } from './sortable-roster.style'

interface ISortableRosterProps {
  roster: IRoster
  isExpanded: boolean
  onToggle: (rosterId: number) => void
  businessId: number
  customIsSelected?: boolean
  customOnSelect?: (rosterId: number) => void
  containerStyle?: React.CSSProperties
  invite_status?: ROSTER_INVITE_STATUS
  enableDragAndDrop?: boolean
  isUnavailable?: boolean
}

export const SortableRoster = ({
  roster,
  isExpanded,
  onToggle,
  businessId,
  customIsSelected,
  customOnSelect,
  containerStyle,
  invite_status,
  enableDragAndDrop = true,
  isUnavailable,
}: ISortableRosterProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: roster.id,
  })

  return (
    <div ref={setNodeRef} style={sortableWrapperStyle(isDragging, transition, transform)}>
      <PositionRelativeBox>
        <RosterSection
          roster={roster}
          isExpanded={isExpanded}
          onToggle={onToggle}
          businessId={businessId}
          customIsSelected={customIsSelected}
          customOnSelect={customOnSelect}
          containerStyle={containerStyle}
          invite_status={invite_status}
          isUnavailable={isUnavailable}
          dragHandle={
            enableDragAndDrop && (
              <GrabWrapper
                {...attributes}
                {...listeners}
                style={{ cursor: 'grab', display: 'flex', alignItems: 'center' }}
                onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => {
                  e.stopPropagation()
                }}
              >
                <FontAwesomeIcon icon={faGripVertical as any} size='lg' color='gray' />
              </GrabWrapper>
            )
          }
        />
      </PositionRelativeBox>
    </div>
  )
}
